// Turn common share links into their embeddable form. Unknown https URLs are used as-is.
export function toEmbedUrl(input: string): string | null {
    let u: URL
    try {
        u = new URL(input.trim())
    } catch {
        return null
    }
    if (u.protocol !== "https:" && u.protocol !== "http:") return null
    const host = u.hostname.replace(/^www\./, "")
    if (host === "youtube.com" || host === "m.youtube.com") {
        const id = u.searchParams.get("v") || u.pathname.match(/\/(?:embed|shorts|live)\/([^/?]+)/)?.[1]
        return id ? `https://www.youtube.com/embed/${id}` : u.href
    }
    if (host === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}`
    if (host === "vimeo.com") {
        const id = u.pathname.match(/\/(\d+)/)?.[1]
        return id ? `https://player.vimeo.com/video/${id}` : u.href
    }
    if (host === "loom.com") return u.href.replace("/share/", "/embed/")
    if (host === "figma.com" && !u.pathname.startsWith("/embed")) {
        return `https://www.figma.com/embed?embed_host=ourboard&url=${encodeURIComponent(u.href)}`
    }
    if (host === "docs.google.com") return u.href.replace(/\/(edit|view)(\?|$)/, "/preview$2")
    return u.href
}

export const hostOf = (url: string) => {
    try {
        return new URL(url).hostname.replace(/^www\./, "")
    } catch {
        return url
    }
}
